/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';

//variables for calc:
$searchbar-height: variables.$searchbar-height;
$searchbar-icon-height: variables.$searchbar-icon-height;

.searchbar {
  grid-area: searchbar;
  display: flex;
  place-items: center;
  height: 60px;

  .MuiTextField-root {
    margin-top: 0 !important;
    .MuiInputBase-formControl {
      width: 450px;
      height: variables.$searchbar-height;
      background-color: white;
      border-radius: calc($searchbar-height/2);
      padding-left: variables.$padding-medium;
    }
    .MuiInputAdornment-root {
      height: variables.$searchbar-icon-height;
      max-height: variables.$searchbar-icon-height;
      width: variables.$searchbar-icon-height;
      justify-content: center;
      color: variables.$color-orange;
      background-color: variables.$color-primary-50;
      border-radius: calc($searchbar-icon-height/2);
    }

    fieldset.MuiOutlinedInput-notchedOutline {
      border-color: variables.$background-color-body;
    }
  }
}

.MuiAutocomplete-popper .MuiAutocomplete-paper {
  ul.MuiAutocomplete-listbox li div.MuiAutocomplete-groupLabel {
    color: variables.$text-color-black-medium-emphasis;
    height: 37px;
    margin-top: 20px;
    line-height: 37px;
    border-bottom: 1px solid variables.$text-color-black-medium-emphasis;
  }
  ul.MuiAutocomplete-listbox li:first-child div.MuiAutocomplete-groupLabel {
    margin-top: 0;
  }
}
